export default __webpack_public_path__ + "static/media/sleevecm.89d41dd2.webp";